const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1497.29 1041.58c.39.01.71.33.71.71 0 .38-.31.71-.7.71h-18.59c-.37 0-.69-.33-.69-.71 0-.38.3-.7.69-.71h18.58Zm-19.27-6.28-.02 3.37c0 .19.07.39.2.52.14.14.31.21.5.21l3.29-.02c.19 0 .36-.07.49-.2l11.38-11.6c.27-.27.27-.72 0-1.02l-3.26-3.36a.719.719 0 0 0-1 0l-2.28 2.34-9.1 9.26c-.12.14-.2.31-.2.5Zm1.41.31 8.38-8.55 2.3 2.34-8.39 8.53-2.31.02.02-2.34Zm10.68-10.88 2.29 2.33-1.29 1.32-2.29-2.34 1.29-1.31Z",
    style: {
      fill: "#727272"
    },
    transform: "translate(-1476 -1021)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic-edit.cbb2e47b54fa44f573c1bb622cf22490.svg";
export { ForwardRef as ReactComponent };